export const MESSAGE_ADD_COURSE_SUCCESS = '강좌를 추가했습니다.';
export const MESSAGE_ENROLL_COURSE_SUCCESS = '수강 신청되었습니다.';
export const MESSAGE_CANNNOT_ENROLL_COURSE_ERROR = '수강 신청할 수 없는 강좌입니다.';



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/shared/course-message.ts